import { isEmpty } from "lodash";
import { createSelector } from "reselect";

const DEFAULT_OBJECT = {};
const DEFAULT_ARRAY = [];

export const getAssigneesStore = (state) => state?.entities?.assignees || DEFAULT_OBJECT;

const getUserIdProp = (state, props) => props?.userId;

export const getUserById = createSelector(
  [getAssigneesStore, getUserIdProp],
  (users, userId) => {
    const result = users?.[userId];
    return isEmpty(result) ? DEFAULT_OBJECT : result;
  }
);
